// extracted by mini-css-extract-plugin
module.exports = {"profilePage":"ProfilePage_profilePage__21adJ","topBar":"ProfilePage_topBar__uw3eS","block":"ProfilePage_block__GFwcv"};